import React, { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import BannerSingle from '../../BannerSingle';
import PageDescription from '../../PageDescription/FAQ';
import Lgpd from '../../Lgpd';
import FAQ from '../../FAQ';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';


class Perguntas extends Component {

	render() {

		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<ErrorBoundary><BannerSingle page={"perguntas-frequentes"} image={"perguntas-frequentes"} /></ErrorBoundary>

				{/* Page description */}
				<ErrorBoundary><PageDescription page={"perguntas-frequentes"} /></ErrorBoundary>

				{/* Content page */}
				<div id="Freq" className="_the-content">
					<div className='container'>
						<div className="row justify-content-center">
							<div className="col-md-10">
								<br/><br/>
								<h3>Perguntas Frequentes</h3>


								<hr />
							</div>
						</div>
					</div>
				</div>
				<ErrorBoundary><FAQ url={"ObterFAQ?Plano=Perguntas Frequentes"}/></ErrorBoundary>
				<div id="FreqA"  className="_the-content">
					<div className='container'>
						<div className="row justify-content-center">
							<div className="col-md-10">

								<h3>Perguntas Frequentes Plano A</h3>


								<hr />
							</div>
						</div>
					</div>
				</div>
				<ErrorBoundary><FAQ url={"ObterFAQ?Plano=Plano A"}/></ErrorBoundary>

				<div id="FreqB"  className="_the-content">
					<div className='container'>
						<div className="row justify-content-center">
							<div className="col-md-10">

								<h3>Perguntas Frequentes Plano B</h3>


								<hr />
							</div>
						</div>
					</div>
				</div>
				<ErrorBoundary><FAQ url={"ObterFAQ?Plano=Plano B"}/></ErrorBoundary>
				<div  id="FreqTaesa"  className="_the-content">
					<div className='container'>
						<div className="row justify-content-center">
							<div className="col-md-10">

								<h3>Perguntas Frequentes Plano Taesaprev</h3>


								<hr />
							</div>
						</div>
					</div>
				</div>
				<ErrorBoundary><FAQ url={"ObterFAQ?Plano=TaesaPrev"}/></ErrorBoundary>



				{/*   */}
				
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default Perguntas;